const initialState = {
  subtotal: '$0',
  adjustments: [],
  total: '$0',
  total_decimal: 0.0,
  subtotal_decimal: 0.0,
}

export default function orderPreview(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_ORDER_PREVIEW':
      return action.payload
    default:
      return state
  }
}
